import React from "react";
import { Component } from "react";

class IITFoundationErrorExamSection extends Component{
    render(){
        return(
            <h4>This is IIT foundation Error Exam page </h4>
        )
    }
}
export default IITFoundationErrorExamSection;